import React, { Component } from "react";
import Recommendation from "../../recommendation/recommendation";

class UserRecommendations extends Component {
  state = {};
  render() {
    const self = this;
    var recommendations = this.props.recommendations.map(function(
      recommendation
    ) {
      return (
        <Recommendation
          recommendation={recommendation}
          key={recommendation.id}
          username={self.props.username}
        />
      );
    });
    return (
      <div
        id=""
        className="center list_questions  pt-2 row recommendation_row recommendation_list"
      >
        {recommendations}
      </div>
    );
  }
}

export default UserRecommendations;



// WEBPACK FOOTER //
// ./src/components/profile/user_data/user_recommendations.jsx